import AbstractIntegration from "./AbstractIntegration.js";

/**
 * `CapegoIntegration` is a concrete implementation of `AbstractIntegration`
 * for integration with Capego.
 */
export default class CapegoIntegration extends AbstractIntegration {
	getName() {
		return "Capego";
	}

	routeName() {
		return "capego";
	}

	isBeta() {
		return true;
	}

	hasInvoiceSupport() {
		return true;
	}

	canBeDisconnected() {
		return false;
	}

	isCapegoIntegration() {
		return true;
	}

	importerCanCreateNewCompany() {
		return false;
	}

	static getType() {
		return "CapegoIntegration";
	}
}
